import { enableScrollChaining } from "@theme/utilities";

function updateProductBoughtTogetherListFade(scrollElement, wrapElement) {
  const isScrollable = scrollElement.scrollHeight > scrollElement.clientHeight + 1;
  wrapElement.classList.toggle("is-scrollable", isScrollable);

  const atEnd = scrollElement.scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight - 1;
  wrapElement.classList.toggle("is-at-end", atEnd);
}

function initProductBoughtTogetherScroll() {
  document.querySelectorAll(".product-bought-together__list-scroll").forEach((scrollElement) => {
    const wrapElement = scrollElement.closest(".product-bought-together__list-wrap");
    if (!wrapElement) return;

    if (scrollElement.dataset.boughtTogetherScrollInit === "true") {
      updateProductBoughtTogetherListFade(scrollElement, wrapElement);
      return;
    }

    scrollElement.dataset.boughtTogetherScrollInit = "true";
    enableScrollChaining(scrollElement);

    const onScroll = () => updateProductBoughtTogetherListFade(scrollElement, wrapElement);
    scrollElement.addEventListener("scroll", onScroll, { passive: true });

    const list = scrollElement.querySelector(".product-bought-together__list");
    const resizeObserver = new ResizeObserver(() =>
      updateProductBoughtTogetherListFade(scrollElement, wrapElement)
    );
    resizeObserver.observe(scrollElement);
    if (list) resizeObserver.observe(list);

    updateProductBoughtTogetherListFade(scrollElement, wrapElement);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductBoughtTogetherScroll);
} else {
  initProductBoughtTogetherScroll();
}

document.addEventListener("shopify:section:load", initProductBoughtTogetherScroll);
